export default __webpack_public_path__ + "static/media/Delete.4abef29c.svg";